import React, { useEffect, useState } from "react";
import {
  Box,
  IconButton,
  Tooltip,
  Button,
  FormControlLabel,
  Switch,
} from "@mui/material";
import CustomDataGrid from "../../CustomDataGrid"; // Ajustá la ruta si es distinta
import { ModeloGetUrl } from "../../ModeloCrud"; // Ajustá la ruta si es distinta
import { toast } from "react-toastify";
import CustomAutoComplete from "../../CustomAutoComplete"; // Ajustá la ruta si es distinta
import { Search } from "@mui/icons-material";
import { LoadingButton } from "@mui/lab";
import {
  Add as AddIcon,
  Search as SearchIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
} from "@mui/icons-material";
import { useAuditoria } from "../contexts/AuditoriaContext";
import ModalHistorialValores from "../modals/ModalHistorialValores";
import ModalInsertarEditarHonorario from "../modals/ModalInsertarEditarHonorario"; // Ajustá la ruta si es distinta
import DeleteModel from "../../DeleteModel"; // Ajustá la ruta si es distinta
import { useLiquidaciones } from "../contexts/LiquidacionesContext";
import { useLiquidarUtils } from "../hooks/useLiquidarUtils"; // Ajustá la ruta si es distinta

export default function ListasHonorariosView() {
  // const [valores, setValores] = useState([]);
  const viewportHeight = window.innerHeight;
  const gridHeight = viewportHeight - 190; // Le restás espacio estimado del layout
  const { selectedListaHonorarios, updateAuditoria } = useAuditoria();
  const [showHistorial, setShowHistorial] = useState(false); // para abrir/cerrar el modal
  const [historial, setHistorial] = useState([]); // para guardar el resultado del historial
  const [modalHonorariosOpen, setModalHonorariosOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null); // para la fila seleccionada
  const [deleteHonorarioId, setDeleteHonorarioId] = useState(null); // para el ID del honorario a borrar
  const {
    updateLiquidaciones,
    selectedListaHonorariosRows,
    searchingValoresHonorarios,
    listasHonorariosRows,
    loadingListas,
    listasActivas,
  } = useLiquidaciones();
  const { handleBuscarValoresListaHonorarios, fetchListas } =
    useLiquidarUtils();

  // Buscar listas al iniciar
  useEffect(() => {
    fetchListas(listasActivas);
    updateAuditoria({ selectedListaHonorarios: null });
    updateLiquidaciones({ selectedListaHonorariosRows: [] });
  }, [listasActivas]);

  const handleUpdateRow = (updatedRow) => {
    const nuevaLista = selectedListaHonorariosRows.map((r) =>
      r.lv_id === updatedRow.lv_id
        ? { ...r, ...updatedRow } // fusiona lo viejo con lo nuevo
        : r
    );
    updateLiquidaciones({ selectedListaHonorariosRows: nuevaLista }); // actualiza el contexto
  };

  const handleAgregarValor = () => {
    setSelectedRow(null); // Resetea la fila seleccionada
    setTimeout(() => {
      setModalHonorariosOpen(true);
    }, 0);
  };
  const hideHonorariosModal = () => {
    setModalHonorariosOpen(false);
  };

  // Buscar valores vigentes de la lista seleccionada

  // Acciones
  const handleVerHistorial = async (row) => {
    console.log("Ver historial:", row);
    try {
      const paramsObj = {
        lista_id: row.lista_id,
        nomenclador_id: row.nom_id,
      };
      const paramsString = new URLSearchParams(paramsObj).toString();
      let result = await ModeloGetUrl(
        "listas-precios-honorarios-val",
        null,
        "obtener-historial-valores",
        paramsString
      );
      console.log("Historial de valores:", result);
      if (
        result.error === false &&
        result.listado &&
        result.listado.length > 0
      ) {
        setHistorial(result.listado);
        setShowHistorial(true);
      }
    } catch (error) {
      toast.error("Error al cargar el historial:", error);
    }
  };

  const handleEditar = (row) => {
    setSelectedRow(row);
    setModalHonorariosOpen(true);
    console.log("Editar:", row);
  };

  const handleBorrar = (row) => {
    setDeleteHonorarioId(row.lv_id);
  };

  // Columnas del DataGrid
  const columnsObject = [
    {
      field: "lv_id",
      headerName: "Id",
      width: 50,
    },
    {
      field: "nombre",
      headerName: "Lista",
      width: 120,
    },
    {
      field: "codigo",
      headerName: "Código",
      width: 120,
      renderCell: (params) => (
        <div style={{ width: "100%", fontWeight: "bold" }}>{params.value}</div>
      ),
    },
    {
      field: "report_descripcion",
      headerName: "Descripción",
      flex: 1,
      width: 250,
      minWidth: 300,
      textTransform: "capitalize",
      wrapLength: 50, // Longitud de envoltura por defecto
    },
    {
      field: "valor",
      headerName: "Valor",
      width: 100,
      valueFormatter: (params) => `$${params.value}`,
      align: "right", // 👈 alinea el contenido de las celdas
      headerAlign: "right", // 👈 alinea también el encabezado
      renderCell: (params) => (
        <div style={{ width: "100%", textAlign: "right", fontWeight: "bold" }}>
          {`$${params.value}`}
        </div>
      ),
    },
    {
      field: "vigencia1",
      headerName: "Vigente Desde",
      width: 130,
      align: "right", // 👈 alinea el contenido de las celdas
      headerAlign: "right", // 👈 alinea también el encabezado
    },
    {
      field: "acciones",
      headerName: "Acciones",
      width: 180,
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <>
          <Tooltip title="Ver historial">
            <IconButton onClick={() => handleVerHistorial(params.row)}>
              <SearchIcon fontSize="small" color="primary" />
            </IconButton>
          </Tooltip>
          <Tooltip title="Modificar">
            <IconButton onClick={() => handleEditar(params.row)}>
              <EditIcon fontSize="small" color="primary" />
            </IconButton>
          </Tooltip>
          <Tooltip title="Borrar">
            <IconButton onClick={() => handleBorrar(params.row)}>
              <DeleteIcon fontSize="small" color="error" />
            </IconButton>
          </Tooltip>
        </>
      ),
    },
  ];

  return (
    <Box sx={{ p: 2 }}>
      {/* Línea superior: Autocomplete + Botón buscar */}
      <Box
        sx={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between", // 👈 separa extremos
          mb: 2,
        }}
      >
        {/* Grupo izquierdo: Autocomplete + Buscar */}
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <CustomAutoComplete
            id="listas"
            sx={{ width: 300 }}
            options={listasHonorariosRows}
            value={selectedListaHonorarios}
            label="Lista de honorarios"
            formik={null}
            getOptionLabel={(option) =>
              option?.nombre
                ?.toLowerCase()
                .split(" ")
                .map((s) => s.charAt(0).toUpperCase() + s.slice(1))
                .join(" ") || ""
            }
            isOptionEqualToValue={(option, value) => option.id === value.id}
            onChange={(_, newValue) => {
              updateAuditoria({ selectedListaHonorarios: newValue ?? null });
              updateLiquidaciones({ selectedListaHonorariosRows: [] });
            }}
          />

          <Tooltip title="Buscar valores vigentes">
            <LoadingButton
              size="medium"
              onClick={handleBuscarValoresListaHonorarios}
              loading={searchingValoresHonorarios}
              loadingPosition="start"
              endIcon={<SearchIcon />}
              sx={{
                backgroundColor: "primary.main",
                ":hover": { bgcolor: "#475569", color: "white" },
                width: 80,
              }}
              variant="contained"
            >
              <span></span>
            </LoadingButton>
          </Tooltip>

          <FormControlLabel
            control={
              <Switch
                checked={listasActivas}
                onChange={(e) =>
                  updateLiquidaciones({ listasActivas: e.target.checked })
                }
              />
            }
            label="Solo activas"
          />
        </Box>

        {/* Botón derecho: Agregar valor */}
        <Button
          variant="contained"
          color="primary"
          startIcon={<AddIcon />}
          onClick={handleAgregarValor}
          disabled={!selectedListaHonorarios || searchingValoresHonorarios}
        >
          Agregar valor
        </Button>
      </Box>

      {selectedListaHonorariosRows?.length > 0 &&
        selectedListaHonorarios &&
        !loadingListas &&
        !searchingValoresHonorarios && (
          <>
            <CustomDataGrid
              columnsObject={columnsObject}
              dataRows={selectedListaHonorariosRows}
              //       sortField="codigo"
              //     sortOrder="desc"
              dynamicRowHeightField="notas"
              columnPercentage={0.4}
              getRowId={(row) => row.lv_id}
              pageSize={100}
              height={gridHeight}
              getRowHeight={(params) => 29}
            />
            <ModalHistorialValores
              open={showHistorial}
              onClose={() => setShowHistorial(false)}
              historial={historial}
            />
            <ModalInsertarEditarHonorario
              showModal={modalHonorariosOpen && selectedListaHonorarios}
              hideModal={hideHonorariosModal}
              row={selectedRow}
              listaRow={selectedListaHonorarios}
              onUpdateRow={handleUpdateRow}
              onAddRow={handleBuscarValoresListaHonorarios}
            />
            {deleteHonorarioId !== null && (
              <DeleteModel
                model={"listas-precios-honorarios-val"}
                modelid={deleteHonorarioId}
                okmethod={handleBuscarValoresListaHonorarios}
                nullmethod={setDeleteHonorarioId}
              />
            )}
          </>
        )}
    </Box>
  );
}
